// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Listar,
  AprovarCadastro,
} from './';

export default {
  path: 'usuarios',
  name: 'Usuarios',
  childRoutes: [
    { path: 'listar', name: 'Listar', component: Listar, isIndex: true },
    { path: 'aprovacoes', name: 'Aprovar cadastro', component: AprovarCadastro },
  ],
};



// WEBPACK FOOTER //
// ./src/features/usuarios/route.js